import { forwardRef, Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrdersSandbox } from 'app/core/sandboxes/orders.sandbox';
import { FilterValues } from 'app/core/interfaces/filtervalues.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import * as fromRoot from '../store';
import { StockCountsShipToLoadAction } from '../store/stock-count/stock-count.actions';
import { BaseGuard, Params } from './base.guard';
import { Observable } from 'rxjs';
import { Definition } from '../store/definitions/definition.interface';
import { LoadState } from '../interfaces/generic.interface';
import { CustomerInfo } from '../store/customer-info/customer-info.interface';
import { first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StockCountLocationsLoadGuard extends BaseGuard<LoadState<Definition[]>> {
  private sandbox: OrdersSandbox;
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => OrdersSandbox)) sandbox) {
    super('StockCountLocationsLoadGuard');
    this.store = store;
  }

  getState(params: Params): Observable<any> {
    return this.store.select(state => state.stockCount.shipTos);
  }

  hasFailed(t: LoadState<Definition[]>, params: Params): boolean {
    return t.loadFailed;
  }

  isLoaded(t: LoadState<Definition[]>, params: Params): boolean {
    return t.loadSuccess;
  }

  isLoading(t: LoadState<Definition[]>, params: Params): boolean {
    return t.loading;
  }

  loader(t: LoadState<Definition[]>, params: Params): void {
    this.store
      .select('customerInfo')
      .pipe(
        first(),
        map((customerInfo: CustomerInfo) => (customerInfo.customer ? customerInfo.customer.id : null))
      )
      .subscribe(customerNr => {
        this.store.dispatch(new StockCountsShipToLoadAction(customerNr));
      });
  }

  navigateAway(params: Params): void {}

  resetter(params: Params): void {}

  versionChecker(t: LoadState<Definition[]>, params: Params): boolean {
    return true;
  }
}
